export function loadScript(
  src: string,
  position: HTMLElement | null,
  id: string,
  attributes?: Record<string, string>
) {
  if (!position) {
    return;
  }

  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  attributes &&
    Object.keys(attributes).forEach(attribute =>
      script.setAttribute(attribute, attributes[attribute])
    );
  script.src = src;
  position.appendChild(script);

  return script;
}
